export default __webpack_public_path__ + "hero-mobile-0eeb7ffad91b221b14675eb36b068644.digested.webp";